import { render, staticRenderFns } from "./OrderPresentation-gt3.vue?vue&type=template&id=98bd1836&scoped=true"
import script from "./OrderPresentation-gt3.vue?vue&type=script&lang=js"
export * from "./OrderPresentation-gt3.vue?vue&type=script&lang=js"
import style0 from "./OrderPresentation-gt3.vue?vue&type=style&index=0&id=98bd1836&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bd1836",
  null
  
)

export default component.exports